import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username) {
  return yield oncallFetch("/api/oncall/partners/users/get-by-username", {
    username,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/get-by-username.js